<template>
    <v-row class="mx-1 my-7">
        <slot name="meta" />

		<v-col v-if="contentData.title" cols="12">
			<h3 class="q-title text-center">{{ contentData.title }}</h3>
		</v-col>

		<slot name="Videos">
			<div class="columns-wrapper align-stretch justify-center" :style="itemsStyle">
				<div v-for="(video, key) in contentData.Videos" :key="key" class="column-item pa-2">
					<q-wistia-player :video="video" />
				</div>
			</div>
		</slot>
    </v-row>
</template>

<script>
import QWistiaPlayer from '@/CMS/views/ContentBlocks/Elements/QWistiaPlayer.vue'
import { CmsGroupViewMixin } from '@/CMS/mixins/CmsGroupMixin'

export default {
    name: 'WistiaVideoGroup',
    components: { QWistiaPlayer },
	mixins: [CmsGroupViewMixin],
    props: {
        contentData: {
            type: Object,
            default: function() {
                return {
                    Videos: [{}],
                    title: null,
                    NumColumns: 4,
                }
            }
        }
    },
}
</script>
